import { QuoteStatus } from './enums'

export const DASHBOARD_PATH = '/dashboard'
export const CUSTOMERS_PATH = '/customers'
export const QUOTATION_TOOL_PATH = '/quotation-tool'
export const DATA_MANAGEMENT_PATH = '/data-management'
export const ADMIN_PATH = '/admin'
export const CUSTOMER_PROFILE_PATH = '/customer-profile'
export const ALL_QUOTES_KEY = 'allQuotesKey'
export const MY_QUOTES_KEY = 'myQuotesKey'

export const QUOTE_SUB_PATH = 'quote-id'
export const MY_QUOTES_PATH = '/quotation-tool/my-quotes'
export const ALL_QUOTES_PATH = '/quotation-tool/all-quotes'
export const MY_QUOTE_FULL_PATH = `${MY_QUOTES_PATH}/${QUOTE_SUB_PATH}/`
export const ALL_QUOTE_FULL_PATH = `${ALL_QUOTES_PATH}/${QUOTE_SUB_PATH}/`

export const QUICK_PRICE_PATH = '/quick-price'
export const QUICK_PRICE_FULL_PATH = `${QUOTATION_TOOL_PATH}${QUICK_PRICE_PATH}`

export const EQUIPMENT_SUB_PATH = 'equipment-id'
export const ATTACHMENT_SUB_PATH = 'attachment-id'
export const SPEC_SUB_PATH = 'spec-id'
export const CUSTOMER_ID_SUB_PATH = 'customer-id'

export const PERMISSIONS_KEY = 'USER_PERMISSIONS'
export const OTHER = 'Other'

export const ACTIVE_SPEC_NAME = 'ACTIVE_SPEC_NAME'

export const PREVENT_NAVIGATION = 'prevent-navigation'
export const IS_PRISTINE_STORAGE_KEY = 'is-pristine'

export const SAVE = 'save'
export const DISCARD = 'discard'

export const DELIVERY_LOCATION_ID = 'deliveryLocationId'
export const BILLING_ADDRESS_ID = 'billingAddressId'
export const CONTACT_INFO_ID = 'contactInfoId'
export const QUOTE_SUMMARY_PATHNAME = 'quoteSummaryPathname'

export const TRANSPORT_OPTION_TYPES = {
  COLLECTION: 'COLLECTION',
  DELIVERY: 'DELIVERY',
  FITTED: 'FITTED'
}

export const BRAND_FAMILIES = {
  BUCKET: 'Bucket',
  HITCH: 'Hitch'
}

export const ARCHIVED_ITEMS = {
  DEALER_FIT: 'DEALER_FIT',
  FACTORY_FIT: 'FACTORY_FIT',
  SERVICE_CONTRACT: 'SERVICE_CONTRACT',
  TRANSPORT: 'TRANSPORT',
  WARRANTY: 'WARRANTY'
}

export const STORED_ARCHIVED_ITEMS = {
  BRAND: 'SELECTED_ARCHIVED_BRAND',
  FAMILY: 'SELECTED_ARCHIVED_FAMILY'
}

export const phoneNumberRegex =
  /\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*/

export const RULE_ACTIONS = {
  REPLACE: 'replace',
  REQUIRE: 'require',
  SUGGEST: 'suggest'
}

export const PERMISSIONS = {
  ALL_QUOTES: 'AllQuotes',
  CUSTOMERS: 'Customers',
  DATA_MANAGEMENT: 'DataManagement',
  MY_QUOTES: 'MyQuotes',
  USERS: 'Users',
  CUSTOMERS_MERGING: 'CustomerMerging',
  IN_STOCK_MAPPING: 'InStockMapping'
}

export const INACTIVE_ROLE = 'inactive'
export const QUOTE_CONFIRMATION_PATH =
  '/quotation-tool/client-quote-confirmation'
export const PREVIEW_QUOTE_CONFIRMATION_PATH =
  '/quotation-tool/preview-quote-confirmation'
export const POST_LOGIN_PATH_LOCAL_STORAGE_KEY = 'postLoginPath'

export const MACHINE_TYPE = {
  ATTACHMENT: 'attachment',
  MACHINE: 'machine'
} as const

export const EQUIPMENT_TYPE = {
  ATTACHMENT: 'attachment',
  EQUIPMENT: 'equipment',
  NO_TYPE: ''
} as const

export const GENERAL_MACHINE_TYPES = {
  ATTACHMENT: 'Attachment',
  MACHINE: 'Machine'
}

export const APPROVAL_STATUSES = [
  QuoteStatus.ACCEPTED,
  QuoteStatus.DRAFT_ACCEPTED_BY_CUSTOMER,
  QuoteStatus.DRAFT_ACCEPTED_ON_BEHALF_OF_CUSTOMER,
  QuoteStatus.DRAFT_REJECTED_BY_CUSTOMER,
  QuoteStatus.DRAFT_SENT_TO_CUSTOMER,
  QuoteStatus.LEVEL_1_APPROVED_PENDING_LEVEL_2_APPROVAL,
  QuoteStatus.PENDING_LEVEL_1_APPROVAL,
  QuoteStatus.PENDING_LEVEL_2_APPROVAL,
  QuoteStatus.REJECTED_INTERNAL_L1,
  QuoteStatus.REJECTED_INTERNAL_L2
]

export const nonEditableStatuses = [
  QuoteStatus.ACCEPTED,
  QuoteStatus.ARCHIVED,
  QuoteStatus.DRAFT_ACCEPTED_BY_CUSTOMER,
  QuoteStatus.DRAFT_ACCEPTED_ON_BEHALF_OF_CUSTOMER,
  QuoteStatus.DRAFT_REJECTED_BY_CUSTOMER,
  QuoteStatus.DRAFT_SENT_TO_CUSTOMER,
  QuoteStatus.LEVEL_1_APPROVED_PENDING_LEVEL_2_APPROVAL,
  QuoteStatus.PENDING_LEVEL_1_APPROVAL,
  QuoteStatus.PENDING_LEVEL_2_APPROVAL,
  QuoteStatus.REJECTED_INTERNAL_L1,
  QuoteStatus.REJECTED_INTERNAL_L2
]

export const trueString = 'True'
export const falseString = 'False'

export const whiteCheckUrl = `url( "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='-3 -4 20 20' fill='none'%3E%3Cpath d='M10.6668 1.5L4.25016 7.91667L1.3335 5' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E" )`

export const greenCheckUrl = `url( "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='-3 -4 20 20' fill='none'%3E%3Cpath d='M10.6668 1.5L4.25016 7.91667L1.3335 5' stroke='%2300938B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E" )`
